<template>
  <el-container>
    <el-aside class="main-aside">
      <el-container>
        <el-header class="left-houselist">
          <el-input placeholder="请输入小区名称" v-model="likeData"></el-input>
          <el-button type="primary" @click="getHousingList()">查询</el-button>
        </el-header>
        <el-main>
          <el-table
            :data="tableData"
            :show-header="false"
            ref="tablesure"
            highlight-current-row
            default-expand-all
            @row-click="houseClick"
            row-key="userId"
            :tree-props="{ children: 'users' }"
          >
            <el-table-column prop="userName" label="名字"> </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </el-aside>
    <el-main class="main-main">
      <el-container class="m-m-c-b">
        <el-header>
          <el-input
            class="h-i-q h-m-r"
            placeholder="请输入姓名搜索"
            v-model="otherData.visitorName"
          ></el-input>
          <el-date-picker
            class="h-m-r"
            v-model="timeall"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            :clearable="false"
            value-format="yyyy-MM-dd"
            @change="gettimeall"
          >
          </el-date-picker>
          <el-button type="primary" @click="clearotherData()"
            >清空条件</el-button
          >
          <el-button type="primary" @click="queryPassList(true)">查询</el-button>
          <el-button type="primary" @click="manualRegistration()"
            >手动登记</el-button
          >

          <!-- 全屏弹框 -->
          <el-dialog
            title="查询用户添加访客"
            fullscreen
            custom-class="dialog-box"
            :visible.sync="manualRegistrStatus"
          >
            <el-container>
              <el-header>
                <el-input
                  class="dialog-input"
                  placeholder="请输入用户姓名"
                  v-model="queryUserInfoParmas.keywords"
                ></el-input>
                <el-button type="primary" @click="getUserInfoList(unitId)"
                  >查询</el-button
                >
              </el-header>
              <el-main class="dialog-m-box">
                <el-table
                  :data="userInfoDataList"
                  border
                  :header-cell-style="{ background: '#409EFF', color: '#fff' }"
                >
                  <el-table-column
                    label="姓名"
                    prop="userName"
                    align="center"
                  ></el-table-column>
                  <el-table-column label="性别" prop="sex"></el-table-column>
                  <el-table-column
                    label="电话"
                    prop="phoneNum"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    label="小区"
                    prop="buildName"
                  ></el-table-column>
                  <el-table-column
                    label="区域"
                    prop="buildNum"
                  ></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button type="primary" @click="addVisitor(scope.row)"
                        >添加访客</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-main>
              <el-footer class="dialog-footer">
                <el-pagination
                  @size-change="handleSizeChangeUser"
                  @current-change="handleCurrentChangeUser"
                  :current-page="queryUserInfoParmas.currentPage"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="queryUserInfoParmas.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalUser"
                >
                </el-pagination>
              </el-footer>
            </el-container>
            <el-dialog
              width="30%"
              title="为对应户主添加访客"
              :visible.sync="manualRegistrStatusIn"
              append-to-body
            >
              <!-- 添加访客 -->
              <el-row class="d-row">
                <el-col :span="12">被访者姓名：</el-col>
                <el-col :span="12">
                  {{ addUserinfo.userName }}
                </el-col>
              </el-row>
              <el-row class="d-row">
                <el-col :span="12">被访者电话：</el-col>
                <el-col :span="12">
                  {{ addUserinfo.phoneNum }}
                </el-col>
              </el-row>
              <el-row class="d-row">
                <el-col :span="12">被访者区域：</el-col>
                <el-col :span="12">
                  {{ addUserinfo.buildNum }}
                </el-col>
              </el-row>
              <el-row class="d-row">
                <el-col :span="12">被访者门号：</el-col>
                <el-col :span="12">
                  {{ addUserinfo.houseNum }}
                </el-col>
              </el-row>
              <el-row class="d-row">
                <el-col :span="12">来访者姓名：</el-col>
                <el-col :span="12">
                  <el-input
                    placeholder="请输入来访者姓名"
                    v-model="addUserinfo.visitorName"
                  ></el-input>
                </el-col>
              </el-row>
              <el-row class="d-row">
                <el-col :span="12">来访者证件：</el-col>
                <el-col :span="12">
                  <el-input
                    placeholder="请输入来访者证件"
                    v-model="addUserinfo.idNum"
                  ></el-input>
                </el-col>
              </el-row>
              <el-row class="d-row">
                <el-col :span="12">来访者电话：</el-col>
                <el-col :span="12">
                  <el-input
                    placeholder="请输入来访者电话"
                    v-model="addUserinfo.visitorPhone"
                  ></el-input>
                </el-col>
              </el-row>
              <el-button @click="manualRegistrStatusIn = false" type="danger"
                >取消</el-button
              >
              <el-button @click="suerAddVistor()" type="primary"
                >确定</el-button
              >
            </el-dialog>
          </el-dialog>
        </el-header>
        <el-main>
          <el-table
            :data="passList"
            border
            :header-cell-style="{ background: '#409EFF', color: '#fff' }"
          >
            <el-table-column
              prop="visitorName"
              label="姓名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="visitorPhone"
              label="电话"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="idNum"
              label="证件"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="icCardId"
              label="IC卡号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="visitorTime"
              label="时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="intervieweeName"
              label="被访者"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="intervieweePhone"
              label="被访者电话"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="unitName"
              label="小区"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="intervieweeBuildNum"
              label="区域"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="intervieweeHouseNum"
              label="房号"
              align="center"
            ></el-table-column>
            <!-- <el-table-column label="操作" align="center" width="120px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  v-if="scope.row.icCardId == '' || scope.row.icCardId == null"
                  @click="addIcCardId(scope.row)"
                  >添加IC卡</el-button
                >
                <el-button type="danger" v-else @click="addIcCardId(scope.row)"
                  >注销IC卡</el-button
                >
              </template>
            </el-table-column> -->
          </el-table>
          <el-dialog
            title="添加IC卡"
            width="30%"
            :visible.sync="addIcCardIdStatus"
          >
            <p>
              <el-input
                placeholder="请输入卡号"
                class="add-i"
                ref="getFocus"
                v-model="visitorIcData.icCardId"
              ></el-input>
            </p>
            <el-button type="danger" @click="addIcCardIdStatus = false"
              >取消</el-button
            >
            <el-button type="primary" @click="sureAddIcCardId()"
              >确定</el-button
            >
          </el-dialog>
        </el-main>
        <el-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="otherData.currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="otherData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-footer>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      tableData: [], //小区列表
      likeData: "", //模糊查询
      //分页参数
      total: 0,
      unitId: "",
      timeall: "",
      otherData: {
        visitorName: "",
        pageSize: 20,
        currentPage: 1,
        startDate: "",
        endDate: "",
        uid: ""
      },
      passList: [],
      photoVisiBle: false,
      photourl: "",
      baseURL: this.$axios.defaults.baseURL,
      Excel: "", //下载的href
      addIcCardIdStatus: false,
      visitorIcData: {
        icCardId: "",
        visitorRecordId: ""
      },
      manualRegistrStatus: false,
      manualRegistrStatusIn: false,
      totalUser: 0,
      userInfoDataList: [],
      queryUserInfoParmas: {
        isUnitId: "",
        keywords: "",
        pageSize: 10,
        currentPage: 1
      },
      addUserinfo: {
        visitorName: "",
        visitorPhone: "",
        idNum: "",
        uid: ""
      }
    };
  },
  computed: {
    ...mapGetters(["userinfo"])
  },
  created() {
    this.getHousingList();
  },
  methods: {
    getHousingList() {
      let url = "/dapi/u/likeSelectUserInfo";
      let params = {
        uid: this.userinfo.uid,
        likeData: this.likeData
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.tableData = [];
          data.data.map(item => {
            if (item.userRoleCode == 3 || item.userRoleCode == 9) {
              this.tableData.push(item);
            }
            if (item.users && item.users.length > 0) {
              let users = item.users.filter(
                k => k.userRoleCode == 3 || k.userRoleCode == 9
              );
              item.users = users;
              this.tableData.push(item);
            }
          });
          // this.tableData = data.data;
          // this.$refs.tablesure.setCurrentRow(this.tableData[0]);
          this.$nextTick(() => {
            this.$refs.tablesure.setCurrentRow(this.tableData[0]);
          });
          if (this.tableData[0].users != undefined) {
            if (
              this.tableData[0].users != "" &&
              this.tableData[0].users.length > 0
            ) {
              this.houseClick(this.tableData[0].users[0]);
              return;
            }
          }
          this.houseClick(this.tableData[0]);
        }
      });
    },
    houseClick(row) {
      this.unitId = row.userId;
      this.timeall = "";
      this.otherData.visitorName = "";
      this.otherData.startDate = "";
      this.otherData.endDate = "";
      this.queryPassList();
    },
    /*
     **  @description 清空条件
     **  @param {}
     **  @return
     **  @author shipingan
     */
    clearotherData() {
      this.timeall = "";
      this.otherData.visitorName = "";
      this.otherData.startDate = "";
      this.otherData.endDate = "";
    },
    /*
     **  @description 查询记录
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryPassList(val) {
      if (val) {
        this.otherData.currentPage = 1
      }
      let url = "/dapi/u/getManualVisitorList";
      let params = { ...this.otherData };
      params.isUnitId = this.unitId;
      params.delFlag = '';
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.passList = [];
          this.total = data.rowCount;
          this.passList = data.data;
        }
      });
    },
    gettimeall() {
      this.otherData.startDate = this.timeall[0];
      this.otherData.endDate = this.timeall[1];
    },
    /*
     **  @description 添加ic卡
     **  @param {}
     **  @return
     **  @author shipingan
     */
    addIcCardId(row) {
      this.visitorIcData.visitorId = row.visitorId;
      this.visitorIcData.isUnitId = row.intervieweeUnitId;
      this.visitorIcData.visitorName = row.visitorName;
      this.visitorIcData.uid = this.userinfo.uid;
      this.addIcCardIdStatus = true;
      this.$nextTick(() => {
        this.$refs.getFocus.focus();
      });
    },
    sureAddIcCardId() {
      let url = "/dapi/u/addICCardIdByVisitorIdOrIdNum";
      let params = { ...this.visitorIcData };
      if (this.visitorIcData.icCardId == "") {
        this.$message.error("请输入卡号");
        return;
      }
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            type: "success",
            message: "添加成功"
          });
          this.queryPassList();
          this.addIcCardIdStatus = false;
        }
      });
    },

    /*
     **  @description //手动登记访客
     **  @param {}
     **  @return
     **  @author shipingan
     */
    manualRegistration() {
      this.getUserInfoList(this.unitId);
      this.manualRegistrStatus = true;
    },
    /*
     **  @description 查询小区住户数据
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getUserInfoList(isUnitId) {
      let url = "/dapi/u/likeUserByName";
      let parmas = {
        isUnitId: isUnitId,
        keywords: this.queryUserInfoParmas.keywords,
        pageSize: this.queryUserInfoParmas.pageSize,
        currentPage: this.queryUserInfoParmas.currentPage
      };
      this.$axios.post(url, this.$qs.stringify(parmas)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.totalUser = data.rowCount;
          this.userInfoDataList = data.data;
        }
      });
    },
    /*
     **  @description 添加访客
     **  @param {}
     **  @return
     **  @author shipingan
     */
    addVisitor(row) {
      this.addUserinfo.uid = this.userinfo.uid;
      Object.assign(this.addUserinfo, row);
      this.manualRegistrStatusIn = true;
    },
    suerAddVistor() {
      let url = "/dapi/u/manualSaveVisitor";
      let params = { ...this.addUserinfo };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            type: "success",
            message: "上传成功"
          });
          this.queryPassList();
          this.manualRegistrStatusIn = false;
          this.manualRegistrStatus = false;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 分页
     **  @param {}
     **  @return
     **  @author shipingan
     */
    handleSizeChange(val) {
      this.otherData.pageSize = val;
      this.queryPassList();
    },
    handleCurrentChange(val) {
      this.otherData.currentPage = val;
      this.queryPassList();
    },
    handleSizeChangeUser(val) {
      this.queryUserInfoParmas.pageSize = val;
      this.getHousingList(this.unitId);
    },
    handleCurrentChangeUser(val) {
      this.queryUserInfoParmas.currentPage = val;
      this.getHousingList(this.unitId);
    }
  }
};
</script>
<style lang="less" scoped>
@box-shadow: 0px 0px 10px #ccc;
.el-container {
  height: 100%;
  .main-aside {
    box-shadow: @box-shadow;
    .left-houselist {
      display: flex;
      box-sizing: border-box;
      padding: 16px 20px;
      justify-content: space-between;
      box-shadow: @box-shadow;
      .el-input {
        width: 180px;
        margin-right: 10px;
      }
    }
    .el-main {
      padding-top: 10px;
    }
  }
  .main-main {
    padding: 0;
    .m-m-c-b {
      min-width: 1000px;
    }
    .el-header {
      text-align: left;
      box-shadow: @box-shadow;
      min-width: 400px;
      line-height: 60px;
      .h-i-q {
        width: 200px;
      }
      .h-m-r {
        margin-right: 10px;
      }
    }
    .el-main {
      // min-width: 1300px;
    }
    .el-link {
      font-size: 12px;
    }
  }
  .el-foolter {
    text-align: center;
  }
  .dialog-input {
    width: 200px;
  }
  .dialog-footer {
    text-align: center;
  }
  .dialog-m-box {
    /deep/ .el-table__header-wrapper {
      line-height: 0 !important;
    }
  }
  /deep/ .dialog-box {
    display: flex;
    flex-direction: column;
    .el-dialog__header {
      padding: 0 20px;
    }
    .el-dialog__body {
      padding-top: 0;
      flex: 1;
    }
  }
  .add-i {
    width: 80%;
  }
  .d-row {
    padding: 10px;
    .el-col {
      .el-input {
        width: 60%;
      }
    }
  }
}
</style>
